import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./web.css";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/Website Development/website-development-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/Website Development/website-development-img-2.jpg"; // right image

import SEO from '../../seo';

export default function Website() {
     const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
             <SEO
                title="Website Development | Horizon WebInfo Pvt Ltd"
                description="Unleash Your Ahmedabad Business Potential with a Powerful Website At Horizon WebInfo Pvt Ltd, we specialize in creating captivating, user-centric websites that leverage the power of HTML, CSS, and JavaScript. Our team of expert developers harnesses these fundamental technologies to build seamless, responsive, and visually stunning websites tailored to your unique brand identity and user [&hellip;]"
                canonical="https://www.hwplindia.com/service/website-development-in-ahmedabad/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/website-development-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Website Development</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Website Development</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section">
                            <p className='email'>
                                At Horizon Webinfo Pvt. Ltd. we specialize in creating captivating, user-centric websites that leverage the power of HTML, CSS, and JavaScript. Our team of expert developers harnesses these fundamental technologies to build seamless, responsive, and visually stunning websites tailored to your unique brand identity and user requirements.
                            </p>
                            <p className='email'>
                                Standing out in the bustling market of Ahmedabad requires a strong online presence. At Horizon Webinfo Pvt. Ltd. we’re a team of passionate <strong> Web Developers in Ahmedabad </strong>dedicated to crafting websites that not only look stunning but also propel your business forward.
                            </p>
                            <section className="cta-section">
                                <h3 className='web-local'>Local Expertise, Global Reach:</h3>
                            </section>
                            <p className='email'>
                                We understand the unique needs of Ahmedabad businesses. Whether you’re a traditional storefront or a modern startup, we’ll create a website that resonates with your local audience while ensuring global visibility.
                            </p>
                            <section className="cta-section">
                                <h3 className='cta-section-business-process it-consult'>Our Services:</h3>
                            </section>
                            <div className="mv-bullet-list web-list">
                                <p><span>Custom Website Development:</span> We don’t believe in cookie-cutter solutions. We build websites tailored to your specific industry, brand identity, and target audience.</p>
                                <p><span>Search Engine Optimization (SEO):</span> Dominate Ahmedabad search results. Our SEO experts optimize your website to rank higher for relevant keywords, attracting organic traffic and potential customers.</p>
                                <p><span>Multilingual Support:</span> Reach a wider audience in Ahmedabad’s diverse market. We offer multilingual website development to cater to local preferences.</p>
                                <p><span>Mobile-First Design:</span> With Ahmedabad’s mobile-savvy population, a responsive website isessential.We ensure your website delivers a flawless user experience on any device.</p>
                                <p><span>E-commerce Integration:</span> Looking to sell online? We seamlessly integrate e-commerce functionalities to your website, enabling secure transactions and a smooth buying experience for your customers.</p>
                                <p><span>Local SEO Optimization:</span> Target local searches and get discovered by customers in your Ahmedabad neighborhood.</p>
                            </div>
                            <section className="cta-section">
                                <h3 className='cta-section-business-process it-consult'>Benefits of Partnering with Us:</h3>
                            </section>
                            <div className="mv-bullet-list web-list">
                                <p><span>Increased Local Visibility:</span>  Attract more customers from your Ahmedabad target market.</p>
                                <p><span>Enhanced Brand Reputation:</span> Establish your business as a leader in Ahmedabad’s digital landscape.</p>
                                <p><span>Improved User Engagement:</span>  Create a user-friendly website that keeps visitors interested and coming back for more.</p>
                                <p><span>Measurable Results:</span> Track website traffic and conversions with our analytics tools to see the impact of your online presence.</p>
                                <p><span>Ongoing Support: </span> Our team is here to provide ongoing maintenance and support to ensure your website stays up-to-date and secure.</p>
                            </div>
                            <p className='email'>
                                <strong>Ready to build a website that reflects the vibrancy of Ahmedabad and fuels your business growth? </strong> Contact Horizon Webinfo Pvt. Ltd. today for a free consultation. Let’s discuss your vision and craft a website that positions you for success in the Ahmedabad market.                            </p>
                        </section>


                        {/* Sections */}
                        <section className='it-consult'>
                            {/* Why Choose Us */}
                            <section className="why-choose">
                                <h3>Why Choose Us</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Expertise in crafting bespoke websites using HTML, CSS, and JavaScript.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Responsive designs for seamless user experiences across all devices.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Precision-driven front-end development expertise.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Optimization for lightning-fast website performance.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Ongoing support and maintenance for sustained success.</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section">
                                <h3>Let's Build Your Digital Presence!</h3>
                                <p>
                                    At Horizon WebInfo Pvt Ltd, we merge creativity with technology to craft exceptional websites powered by HTML, CSS, and JavaScript. Partner with us to bring your vision to life!

                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}